import React, { useEffect, useState } from "react";
import { useParams } from 'react-router';
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import { BasicTable } from '@synergy/table';
import { Flex } from 'antd';
import { Text } from '../../../../Atomics/Text';

export const BuildingRelatedAssetsTable = ({ hasRelatedAssets }) => {
    const { t } = useTranslation();
    const { id } = useParams();

    /*const [rlData, setRlData] = useState(null);
     const { data: relatedLinksData, isLoading: relatedLinksLoading, refetch: refetchRelatedLinks } = useFetch(query.path.relatedLinks, 'getRelatedLinks', { id: id, language: i18next.resolvedLanguage });

    useEffect(() => {
      if (relatedLinksData?.data) {
        setRlData(relatedLinksData?.data);
         hasRelatedAssets(true) 
      } else {
         hasRelatedAssets(false) 
      }
    }, [relatedLinksData]); */

    let rlData = [
        {
            "id": "14c6d25a-e49a-f8ad-aa12-5ac8798ffff4",
            "key": "14c6d25a-e49a-f8ad-aa12-5ac8798ffff4",
            "name": "TA2310409312",
            "class": "String Inverter",
            "type": "Resource"
        },
        {
            "id": "12c6b53e-226a-74dc-9c47-bb067b593d09",
            "key": "12c6b53e-226a-74dc-9c47-bb067b593d09",
            "name": "PT0002000066428994AY",
            "class": "Electricity Meter",
            "type": "Resource"
        },
        {
            "id": "50c6b4ed-d05e-3f2b-81f0-98b4f2518487",
            "key": "50c6b4ed-d05e-3f2b-81f0-98b4f2518487",
            "name": "PT1601000000529649ZA",
            "class": "Gas Meter",
            "type": "Resource"
        }
    ]
    return (
        <Flex id='Related Assets' className='ant-anchors-content-item' gap={32} vertical="true">
            <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{t('Related Assets')}</Text>
            <BasicTable tableId='tableIdTthree' fetchData={rlData} hrefLink={null} language={i18next.resolvedLanguage} />
        </Flex>
    )
}